import cn from 'classnames'
import { Fragment, memo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { IMenuProps } from './models'

import styles from './Menu.module.scss'

export const Menu = memo<IMenuProps>(
  ({ groups, classes, color, variant, activeItemId, onMenuItemClick }) => {
    const visibleGroups = groups
      .map((group) => ({
        ...group,
        items: group.items.filter((item) => !item.hidden),
      }))
      .filter((group) => group.items.length > 0)

    return (
      <div className={cn(classes?.menu, styles.menu)}>
        {visibleGroups.map((group, groupIndex) => {
          return (
            <Fragment key={group.key}>
              {group.items.map((item) => {
                const preparedTitle =
                  typeof item.child.props.title !== 'string' ? (
                    item.child.props.title
                  ) : (
                    <Translation text={item.child.props.title} span />
                  )

                return (
                  <Button
                    color={color}
                    key={`${group.key}-${String(item.id)}`}
                    active={item.id === activeItemId}
                    className={cn(styles.menuItem, classes?.menuItem)}
                    onClick={() => onMenuItemClick(item)}
                    variant={variant}
                  >
                    {preparedTitle}
                  </Button>
                )
              })}
              {groupIndex < visibleGroups.length - 1 ? (
                <div className={cn(styles.menuSeparator, classes?.menuSeparator)}>
                  <hr className="menu-separator" />
                </div>
              ) : null}
            </Fragment>
          )
        })}
      </div>
    )
  }
)

Menu.displayName = 'Menu'
